import { create } from 'zustand';
import { Action } from './shared/types';

interface ActionBarState {
  actionBarOpened: boolean;
  toggleActionBarOpened: () => void;
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  reopen: Action | null;
  setReopen: (reopen: Action | null) => void;
  openAction: Action | null;
  setOpenAction: (openAction: Action | null) => void;
  autoOpenInvite: boolean;
  setAutoOpenInvite: (autoOpenInvite: boolean) => void;
  resizeWidth: number;
  setResizeWidth: (resizeWidth: number) => void;
}

export const actionBarState = create<ActionBarState>((set, get) => ({
  actionBarOpened: false,
  toggleActionBarOpened: () => {
    set({ actionBarOpened: !get().actionBarOpened });
  },
  isOpen: false,
  setIsOpen: (isOpen) => {
    set({ isOpen });
    if (!isOpen) return;
    get().setReopen(null);
  },
  reopen: null,
  setReopen: (reopen) => set({ reopen }),
  openAction: null,
  setOpenAction: (openAction) => set({ openAction }),
  autoOpenInvite: true,
  setAutoOpenInvite: (autoOpenInvite) => set({ autoOpenInvite }),
  resizeWidth: 0,
  setResizeWidth: (resizeWidth) => set({ resizeWidth }),
}));

export const useActionBarState = actionBarState;
